/*  GLOBAL HEADER HEIGHT
*   The global header height is used to give some items a proper position
========================================================================== */

// Import dependency
import { throttle } from './throttle';

// Get the height of the global nav header to set the anchor nav offset
if (document.querySelector('.site-header')) {
  function globalNavHeaderHeight() {
    return document.documentElement.style.setProperty(
      '--global-nav-header-height',
      document.querySelector('.site-header').offsetHeight + 'px'
    );
  }

  window.addEventListener('resize', throttle(globalNavHeaderHeight, 200));
  window.addEventListener('load', globalNavHeaderHeight);
}
